import { render } from "./UserAccountDelete.vue?vue&type=template&id=1f9dc1ab"
import script from "./UserAccountDelete.vue?vue&type=script&lang=js"
export * from "./UserAccountDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__